import { z } from 'zod';
export const FONT_ALLOWLIST = [
    'Inter',
    'Fraunces',
    'Manrope',
    'Source Sans 3',
    'Plus Jakarta Sans',
    'IBM Plex Sans',
    'Lora',
    'Spectral',
    'Playfair Display',
    'Roboto',
    'Roboto Mono',
    'JetBrains Mono',
    'Work Sans',
    'Nunito',
    'Poppins',
    'Outfit',
    'DM Sans',
    'DM Serif Display',
    'Merriweather',
    'Crimson Text',
];
const HEX = z.string().regex(/^#[0-9a-fA-F]{6}$/, 'must be a #RRGGBB hex color');
export const ColorTokensSchema = z
    .object({
    primary: HEX,
    onPrimary: HEX,
    primaryContainer: HEX.optional(),
    secondary: HEX,
    background: HEX,
    surface: HEX,
    onSurface: HEX,
    error: HEX,
    success: HEX.optional(),
    warning: HEX.optional(),
})
    .strict();
export const TypographySchema = z
    .object({
    headingFamily: z.enum(FONT_ALLOWLIST),
    bodyFamily: z.enum(FONT_ALLOWLIST),
    scale: z.enum(['compact', 'comfortable', 'spacious']).default('comfortable'),
})
    .strict();
export const ShapeSchema = z
    .object({
    cornerRadius: z.number().int().min(0).max(48).default(12),
    density: z.enum(['compact', 'regular', 'comfortable']).default('regular'),
})
    .strict();
export const ThemeDocSchema = z
    .object({
    version: z.literal(1).default(1),
    name: z.string().min(1).max(80),
    light: ColorTokensSchema,
    dark: ColorTokensSchema.optional(),
    typography: TypographySchema,
    shape: ShapeSchema,
    logoPath: z.string().nullable().optional(),
    splashImagePath: z.string().nullable().optional(),
})
    .strict();
//# sourceMappingURL=theme.js.map